import GenericHead from "@/src/components/Head/GenericHead";
import VideoModal from "@/src/components/Modal/Video";
import VideoCard from "@/src/components/cards/VideoCard";
import TopVideoCard from "@/src/components/cards/VideoCard/TopVideoCard";
import ContentContainer from "@/src/components/containers/ContentContainer";
import { YoutubeVideo, getChannelVideos, getYoutubeVideosFromMultipleChannels } from "@/src/utils/youtube";

import { GetStaticProps } from "next";
import { useState } from "react";

export interface VideoProps {
  props: {
    data: {
      videos: YoutubeVideo[];
    };
  };
  videos: YoutubeVideo[];
}
const Videos = ({ props, videos = [] }: VideoProps) => {
  const topVideo = videos[0];
  const [videoPlayingId, setVideoPlayingId] = useState<string | null>(null);

  const handleModalOpen = (open: boolean) => {
    if (!open) {
      setVideoPlayingId(null);
    }
  };

  return (
    <>
      <GenericHead title="SCPB Videos" />

      <div className="bg-neutral-100">
        <ContentContainer>
          <div className={"h-[330px] video-flag-container"}>
            <TopVideoCard
              id={topVideo?.id ?? ""}
              title={topVideo?.title}
              image={topVideo?.largeThumbnail}
              url={topVideo?.id}
              onClick={(id: string) => setVideoPlayingId(id)}
            />
          </div>
        </ContentContainer>
        <ContentContainer>
          <div
            className={"flex flex-wrap gap-2"}
            style={{ marginTop: "-1rem" }}
          >
            {videos?.map(function (video: YoutubeVideo, index: number) {
              if (index > 0) {
                return (
                  <div
                    className={"w-[100%] md:w-[49%] lg:w-[31%] video-card"}
                    key={`index-${index}`}
                  >
                    <VideoCard
                      video={video}
                      onClick={(id: string) => setVideoPlayingId(id)}
                    />
                  </div>
                );
              } else {
                return <></>;
              }
            })}
          </div>
        </ContentContainer>
      </div>
      <VideoModal
        id={videoPlayingId}
        open={Boolean(videoPlayingId)}
        setOpen={handleModalOpen}
      />
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  // const youtubeVideos: YoutubeVideo[] = await getChannelVideos(5);
  const youtubeVideos: YoutubeVideo[] = await getYoutubeVideosFromMultipleChannels();

  return {
    props: {
      videos: youtubeVideos
    },
    revalidate: 86400,
  };
};

export default Videos;
